import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DPIDEFECTCLASSSELECT } from 'src/app/common/constants/labels';
import { PivotDefectsClass } from 'src/app/common/models/incident-dashboard-filterparameterdata';

@Component({
  selector: 'app-defects-count-block',
  templateUrl: './defects-count-block.component.html',
  styleUrls: ['./defects-count-block.component.scss']
})
export class DefectsCountBlockComponent implements OnInit, OnChanges {
  @Input() defectClassArray: Array<PivotDefectsClass> = [];
  dpiDefectClass = [];
  dpiDefectACount: number;
  dpiDefectBCount: number;
  dpiDefectCCount: number;
  dpiDefectDCount: number;
  constructor() {
    this.dpiDefectACount = 0;
    this.dpiDefectBCount = 0;
    this.dpiDefectCCount = 0;
    this.dpiDefectDCount = 0;
  }
  ngOnInit() {
  }
  ngOnChanges() {
    this.dpiDefectClass = [];
    this.dpiDefectACount = 0;
    this.dpiDefectBCount = 0;
    this.dpiDefectCCount = 0;
    this.dpiDefectDCount = 0;
    this.defectClassArray.forEach(e => {
      if (e.dpidefectclass === DPIDEFECTCLASSSELECT[0]) {
        this.dpiDefectACount = e.count;
      }
      if (e.dpidefectclass === DPIDEFECTCLASSSELECT[1]) {
        this.dpiDefectBCount = e.count;
      }
      if (e.dpidefectclass === DPIDEFECTCLASSSELECT[2]) {
        this.dpiDefectCCount = e.count;
      }
      if (e.dpidefectclass === DPIDEFECTCLASSSELECT[3]) {
        this.dpiDefectDCount = e.count;
      }
    });
  }
}
